import { render, staticRenderFns } from "./person_duty_note.vue?vue&type=template&id=09eae945&scoped=true"
import script from "./person_duty_note.vue?vue&type=script&lang=js"
export * from "./person_duty_note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09eae945",
  null
  
)

export default component.exports